module.exports = __webpack_public_path__ + "static/media/6.242683b5.jpg";